// @flow
import { positionBottom, positionTop, positionRight, positionLeft } from './theme';
/*::
  import type { TooltipPosition } from './index';
  import type { TooltipThemeType } from './theme';

  type CalculateRelativePositionProps = {
    tooltipPosition: TooltipPosition;
    tooltipHeight: number;
    tooltipWidth: number;
  };

  type CalculateArrowPositionProps = {
    tooltipPosition: TooltipPosition,
    theme: TooltipThemeType
  };
*/

export var calculateRelativePosition = function calculateRelativePosition(_ref
/*: CalculateRelativePositionProps */
) {
  var tooltipPosition = _ref.tooltipPosition,
      tooltipHeight = _ref.tooltipHeight,
      tooltipWidth = _ref.tooltipWidth;

  switch (tooltipPosition) {
    case 'bottom':
      return positionBottom(tooltipHeight);

    case 'top':
      return positionTop(tooltipHeight);

    case 'right':
      return positionRight(tooltipWidth);

    case 'left':
      return positionLeft(tooltipWidth);

    default:
      return positionBottom(tooltipHeight);
  }
};
export var calculateArrowPosition = function calculateArrowPosition(_ref2
/*: CalculateArrowPositionProps */
) {
  var tooltipPosition = _ref2.tooltipPosition,
      theme = _ref2.theme;

  switch (tooltipPosition) {
    case 'top':
      return theme.ArrowBottomCss;

    case 'right':
      return theme.ArrowLeftCss;

    case 'bottom':
      return theme.ArrowTopCss;

    case 'left':
      return theme.ArrowRightCss;

    default:
      return theme.ArrowTopCss;
  }
};